<template>
  <div />
</template>

<script>
import profileMixin from '~/mixins/profileMixin';

export default {
  name: 'CompanyProfile',
  mixins: [profileMixin],
  layout: 'profile',
};
</script>
